import React from 'react'
import {Redirect, Route} from 'react-router-dom'

const ProtectedRoute = ({ component: Component, path }) => {
    if (localStorage.getItem('uid')) {
        return <Route exact path={path} component={Component} />
    } else {
        return <Redirect to='/app' />
    }
}

 export default ProtectedRoute;